var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22245(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22245",
    "data-name": "Group 22245",
    transform: "translate(-547 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22241",
    "data-name": "Group 22241",
    transform: "translate(252 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_7148740_category_variety_random_shuffle_icon",
    "data-name": "7148740_category_variety_random_shuffle_icon",
    transform: "translate(567.783 2065.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27647",
    "data-name": "Path 27647",
    d: "M14.787,18.672H4.268A4.022,4.022,0,0,1,.25,14.655V4.267A4.022,4.022,0,0,1,4.268.25H14.787A4.022,4.022,0,0,1,18.8,4.267V14.655a4.022,4.022,0,0,1-4.017,4.017ZM4.268,3.361a.908.908,0,0,0-.907.906V14.655a.908.908,0,0,0,.907.906H14.787a.907.907,0,0,0,.906-.906V4.267a.907.907,0,0,0-.906-.906Z",
    transform: "translate(0 0)",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27648",
    "data-name": "Path 27648",
    d: "M14.828,38.367H4.309A4.023,4.023,0,0,1,.291,34.349V23.962a4.022,4.022,0,0,1,4.018-4.017H14.828a4.022,4.022,0,0,1,4.014,4.017V34.349a4.022,4.022,0,0,1-4.014,4.018ZM4.309,23.056a.908.908,0,0,0-.907.906V34.349a.908.908,0,0,0,.907.907H14.828a.908.908,0,0,0,.906-.907V23.962a.907.907,0,0,0-.906-.906Z",
    transform: "translate(0.01 4.811)",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27649",
    "data-name": "Path 27649",
    d: "M34.376,38.367H23.857a4.023,4.023,0,0,1-4.018-4.018V23.962a4.022,4.022,0,0,1,4.018-4.017H34.376a4.022,4.022,0,0,1,4.017,4.017V34.349a4.022,4.022,0,0,1-4.017,4.018Zm-10.519-15.3a.908.908,0,0,0-.907.906V34.355a.908.908,0,0,0,.907.907H34.376a.908.908,0,0,0,.906-.907V23.962a.907.907,0,0,0-.906-.906Z",
    transform: "translate(4.786 4.811)",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27650",
    "data-name": "Path 27650",
    d: "M29.094,18.671a9.208,9.208,0,1,1,9.276-9.208,9.208,9.208,0,0,1-9.276,9.208Zm0-15.3a6.1,6.1,0,1,0,0-.006Z",
    transform: "translate(4.814 0.001)",
    fill: "#6d4eec",
    stroke: "#6d4eec",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22245);
export default __webpack_public_path__ + "static/media/Group 22245.fce052aa10e27c44770f305287e967b9.svg";
export { ForwardRef as ReactComponent };